export default {
    browser_title: "Kevi | Automatic UTM",
    page_title: "Automatic UTM",
    page_description:
        "Configure UTM parameters to be automatically added to links in notifications",
    success_message: "Successfully updated",
    error_save: "Error saving",
    error_save_config: "Error saving configurations",
    token_copied: "Token successfully copied!",
    toggle: {
        label: "Enable Automatic UTM",
        hint: "When enabled, UTM parameters will be automatically added or replaced in all links found in notifications.",
    },
    channels: {
        title: "Channels",
        description:
            "Select which channels the automatic UTM will be applied to:",
        email: "Email",
        sms: "SMS",
        rcs: "RCS",
        whatsapp: "WhatsApp",
        whatsapp_cloud: "WhatsApp Cloud",
    },
    tokens: {
        title: "Available Tokens",
        description:
            "Use these tokens in the fields below to customize UTM values:",
        copy: "Copy",
    },
    params: {
        title: "UTM Parameters",
        description:
            "Configure the values for each UTM parameter. Use the tokens above for customization.",
        source: {
            label: "UTM Source",
            hint: "Identifies the source of traffic",
            placeholder: "Ex: [[automation_name]]",
        },
        medium: {
            label: "UTM Medium",
            hint: "Identifies the communication medium",
            placeholder: "Ex: [[channel]]",
        },
        campaign: {
            label: "UTM Campaign",
            hint: "Identifies the specific campaign",
            placeholder: "Ex: [[automation_name]] - [[date]]",
        },
    },
    info: {
        important: "Important:",
        description:
            "If a link already contains UTM parameters (utm_source, utm_medium, utm_campaign), they will be replaced by the values configured here.",
    },
    actions: {
        save: "Save Settings",
    },
};
